export class TableProperty {
  width: string;
  height: string;
  thead: Thead;
  tbody: Tbody;
  lineHeight: string;
}

export class Thead {
  backgroundColor: string;
  color: string;
}

export class Tbody {
  backgroundColor: string;
  color: string;
}
